import React from "react";
import BRAND_IMAGES from "@/lib/brand";

const Host = () => {
  return (
    <section
      id="host"
      className="py-24 md:py-36 bg-ivory relative"
      data-testid="host-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-12 md:gap-20 items-center">
        {/* Portrait, left, asymmetric */}
        <div className="md:col-span-5 fade-up">
          <div
            className="host-image-wrap"
            style={{
              boxShadow: "0 50px 100px -40px rgba(70, 50, 20, 0.32)",
            }}
          >
            <img
              src={BRAND_IMAGES.hostPortraitElegant}
              alt="Persephone Dennis, founder of The Journey to Freedom and the Pathway to Source methodology."
              className="w-full h-auto block"
              data-testid="host-portrait"
              loading="lazy"
            />
          </div>
        </div>

        {/* Bio, right */}
        <div className="md:col-span-7 fade-up delay-200">
          <p className="eyebrow" data-testid="host-overline">
            Meet Your Host
          </p>
          <h2
            className="mt-5 font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight balance"
            style={{ color: "var(--ink)" }}
            data-testid="host-headline"
          >
            <span
              className="font-script block text-5xl md:text-7xl"
              style={{ color: "var(--gold-deep)" }}
            >
              Persephone
            </span>
            <span className="block">Dennis</span>
          </h2>

          <div className="mt-8 space-y-5 leading-relaxed text-[color:var(--ink-soft)] pretty"
               style={{ fontSize: "1.15rem" }}>
            <p data-testid="host-bio-1">
              This masterclass is hosted by{" "}
              <span style={{ color: "var(--ink)" }}>Persephone Dennis</span>,
              creator of <em>The Journey to Freedom</em> series and the{" "}
              <em>Pathway to Source</em> methodology.
            </p>
            <p data-testid="host-bio-2">
              Through her work, she helps women reconnect with who they truly
              are, release the patterns holding them back, and create lives
              aligned with purpose, freedom and fulfilment.
            </p>
            <p
              className="font-serif italic pt-2"
              style={{ color: "var(--ink)", fontSize: "1.65rem", lineHeight: 1.3 }}
            >
              "You are not here to do more. You are here to become more of who
              you already are."
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Host;
